import React from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { monthLabel } from './shared';

const LINES = [{ key: 'google', label: 'Google', colour: '#f59e0b' }, { key: 'meta', label: 'Meta', colour: '#2563eb' }];

function TrendTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return (
    <div className="bg-white border border-gray-200 rounded shadow-sm px-3 py-2 text-xs" data-testid="lead-trend-tooltip">
      <div className="font-semibold text-gray-900 mb-1">{label}</div>
      {LINES.map((l) => (
        <div key={l.key} className="flex items-center gap-2 py-0.5">
          <span className="w-2 h-2 rounded-full" style={{ background: l.colour }} />
          <span className="text-gray-600">{l.label}</span>
          <span className="ml-auto tabular-nums text-gray-900"><b>{row[`${l.key}_total`]}</b> enquir{row[`${l.key}_total`] === 1 ? 'y' : 'ies'} · {row[`${l.key}_booked`]} booked</span>
        </div>
      ))}
    </div>
  );
}

export function LeadSourceTrend({ months }) {
  if (!months?.length) return null;
  const data = months.map((m) => ({ ...m, name: monthLabel(m.month) }));
  const peak = Math.max(0, ...data.flatMap((m) => [m.google_total, m.meta_total]));
  return (
    <div className="mt-5 pt-4 border-t" data-testid="lead-source-trend">
      <div className="flex items-baseline gap-2 mb-2">
        <h3 className="text-sm font-semibold text-gray-900">Google vs Meta — enquiries per month</h3>
        <span className="text-[11px] text-gray-500">Hover a month for counts and how many booked</span>
      </div>
      <div className="h-52">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} allowDecimals={false} width={32} domain={[0, Math.max(2, peak)]} />
            <Tooltip content={<TrendTooltip />} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            {LINES.map((l) => (
              <Line key={l.key} type="linear" dataKey={`${l.key}_total`} name={l.label} stroke={l.colour} strokeWidth={2.5} dot={{ r: 3 }} activeDot={{ r: 5 }} isAnimationActive={false} />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
